import React from 'react';
import {
  FDStack,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useSurveyStepContext } from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { ImageRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ImageRel';
import SurveyFixedFooterActions from 'Views/Onboarding/Pages/Survey/SurveyFixedFooterActions';
import NextButton from 'Views/Onboarding/Components/Navigator/NextButton';
import { DS_SIZE_MAP } from 'Components/ComponentLibrary/DesignSystem/sizes';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import useMobileLayout from 'Hooks/useMobileLayout';

function CompleteMemberConciergeChoosePathLayout() {
  const {
    resource,
    onSubmit,
  } = useMetaLayoutContext();
  const isMobile = useMobileLayout();
  const [selfServiceOnboardingLoading, setSelfServiceOnboardingLoading] = React.useState(false);
  const [conciergeOnboardingLoading, setConciergeOnboardingLoading] = React.useState(false);
  const { displayErrorMessage } = useSnackbarContext();

  const {
    onClickNext,
    setOnboardingStepCollection,
  } = useSurveyStepContext();

  const onSelfServiceOnboardingClick = async () => {
    setSelfServiceOnboardingLoading(true);
    try {
      const [memberRequestResource] = await resource.relationship(fr.relationships.selfServiceOnboardingWithMemberRequest.name).link('related').get();
      const [respResource] = await memberRequestResource.submit();
      if (!respResource.relationship(fr.relationships.redirect.name)) {
        throw new Error('Unable to redirect');
      }

      const newStep = await respResource.relationship(fr.relationships.redirect.name).link('related').get();
      setOnboardingStepCollection(newStep);
    } catch (e) {
      if (e.errors) {
        displayErrorMessage(e, e.errors);
      } else {
        displayErrorMessage(e, 'Failed to click, please try again');
      }
    } finally {
      setSelfServiceOnboardingLoading(false);
    }
  };

  const onConciergeOnboardingClick = async () => {
    setConciergeOnboardingLoading(true);
    try {
      const [memberRequestResource] = await resource.relationship(fr.relationships.conciergeOnboarding.name).link('related').get();
      await memberRequestResource.submit();
      await onClickNext(onSubmit);
    } catch (e) {
      if (e.errors) {
        displayErrorMessage(e, e.errors);
      } else {
        displayErrorMessage(e, 'Failed to click, please try again');
      }
    } finally {
      setConciergeOnboardingLoading(false);
    }
  };

  return (
    <FDStack spacing={4} direction={'column'}>
      <FDStack spacing={6} direction={'column'}>
        <ImageRel relationship={resource.relationship(fr.relationships.image.name)} />
        <MetaControlField attr={'title'} simpleRootStyle />
        <MetaControlField attr={'subtitle'} simpleRootStyle />
      </FDStack>
      <SurveyFixedFooterActions>
        <FDStack spacing={1} direction={'row'} wrap={isMobile}>
          {resource.withRelationship(fr.relationships.selfServiceOnboardingWithMemberRequest.name, (rel) => (
            <RoundedButton
              onClick={onSelfServiceOnboardingClick}
              disableElevation
              variant="contained"
              isLoading={selfServiceOnboardingLoading}
              disabled={conciergeOnboardingLoading}
              color={'primary'}
              fullWidth
              size={DS_SIZE_MAP.sm}
              test={'self-service-onboarding-button'}
            >
              {rel.meta('prompt')}
            </RoundedButton>
          ),
          () => null)}
          {resource.withRelationship(fr.relationships.conciergeOnboarding.name, (rel) => (
            <NextButton
              buttonLabel={rel.meta('prompt')}
              onClick={onConciergeOnboardingClick}
              isLoading={conciergeOnboardingLoading}
              disabled={selfServiceOnboardingLoading}
            />
          ),
          () => null)}
        </FDStack>
      </SurveyFixedFooterActions>
    </FDStack>
  );
}

CompleteMemberConciergeChoosePathLayout.propTypes = {
};

CompleteMemberConciergeChoosePathLayout.defaultProps = {
};

export default CompleteMemberConciergeChoosePathLayout;
